module.exports = {
  siteTitle: 'Elektro-Bechert GmbH', // Site title.
  siteTitleAlt: 'Elektro Meister Bernd Bechert', // Alternative site title for SEO.
  siteLogo: '/icons/icon-512x512.png', // Logo used for SEO and manifest.
  siteUrl: 'https://http://elektro-bechert.de', // Domain of your website without pathPrefix.
  pathPrefix: '', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'Die Firmenwebsite von Elektro Bechert.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  copyright: 'Copyright © Elektro-Bechert GmbH', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
}
